import React from 'react';
import { CircleAlert, X } from 'lucide-react';
import clsx from 'clsx';
import { useLanguage } from '../contexts/LanguageContext';

export const ConfirmModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title, 
    message, 
    confirmText, 
    cancelText,
    type = 'warning' // 'warning' | 'danger' | 'info'
}) => {
    const { t, isRtl } = useLanguage();

    if (!isOpen) return null;

    const colors = {
        warning: 'text-purple-500 bg-purple-500/10 border-purple-500/20',
        danger: 'text-rose-500 bg-rose-500/10 border-rose-500/20',
        info: 'text-blue-500 bg-blue-500/10 border-blue-500/20'
    };

    const buttonColors = {
        warning: 'bg-purple-600 hover:bg-purple-500 text-white',
        danger: 'bg-rose-500 hover:bg-rose-600 text-white',
        info: 'bg-blue-500 hover:bg-blue-600 text-white'
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm animate-in fade-in duration-200" dir={isRtl ? 'rtl' : 'ltr'}>
            <div className="card-premium w-full max-w-sm overflow-hidden animate-in zoom-in-95 duration-200 border-white/10 shadow-2xl">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-white/5 bg-slate-900/50">
                    <div className="flex items-center gap-2">
                        <CircleAlert className={clsx("w-5 h-5", colors[type].split(' ')[0])} />
                        <h3 className="font-bold text-slate-100">{title || t('confirmAction')}</h3>
                    </div>
                    <button onClick={onClose} className="p-1 hover:bg-white/5 rounded-full transition-colors">
                        <X className="w-5 h-5 text-slate-500" />
                    </button>
                </div>

                {/* Body */}
                <div className="p-6">
                    <p className="text-slate-300 text-center leading-relaxed font-heebo">
                        {message || t('confirmMessage')}
                    </p>
                </div>

                {/* Footer */}
                <div className="p-4 bg-slate-900/50 border-t border-white/5 flex gap-3">
                    <button
                        onClick={onConfirm}
                        className={clsx(
                            "flex-1 py-2.5 rounded-xl font-bold transition-all active:scale-95 shadow-lg",
                            buttonColors[type]
                        )}
                    >
                        {confirmText || t('confirm')}
                    </button>
                    <button
                        onClick={onClose}
                        className="flex-1 py-2.5 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-xl font-bold transition-all active:scale-95 border border-white/5"
                    >
                        {cancelText || t('cancel')}
                    </button>
                </div>
            </div>
        </div>
    );
};
